module.exports = __webpack_public_path__ + "static/media/dge2.png.b3087c0b.jpg";